<template>
  <div class="header-wrapper" :class="{ 'is-sticky': isSticky }">
    <!-- 极简工具栏 -->
    <div class="top-utility">
      <div class="container">
        <div class="u-left">
          雪狮光环HaloMRO商城
        </div>
        <div class="u-right">
          <template v-if="!isLoggedIn">
            <router-link to="/login">登录</router-link>
          </template>
          <template v-else>
            <span class="welcome-text">欢迎您，{{ username }}</span>
            <a href="#" @click.prevent="handleLogout" class="logout-link">退出</a>
          </template>
          <span class="sep"></span>
          <router-link to="/order">我的订单</router-link>
          <router-link to="/user">个人中心</router-link>
           <template v-if="isLoggedIn">
             <router-link v-if="userInfo.customerType === '2' && userInfo.companyAuditStatus === '0'" to="/member/apply" class="member-link">Halo会员</router-link>
             <span v-else-if="userInfo.customerType === '2' && userInfo.companyAuditStatus === '1'" class="member-review-tip">会员审核中</span>
           </template>
           <router-link v-else to="/member/apply" class="member-link">Halo会员</router-link>
        </div>
      </div>
    </div>

    <!-- 一体化主航道 -->
    <div class="main-header-unified">
      <div class="container header-content">
        <!-- Logo Area -->
        <div class="logo-area">
          <router-link to="/">
            <!-- <h1 class="brand-text">雪狮<span>.</span>MRO</h1> -->
			     <img src="@/assets/images/logo.png" alt=""  width="166"/>
          </router-link>
        </div>

        <!-- 悬浮型分类触发器 -->
        <router-link to="/list" class="category-trigger">
          <div class="trigger-btn">
            <div class="menu-icon">
              <span></span><span></span><span></span>
            </div>
            <span>全部分类</span>
          </div>
        </router-link>

        <!-- 一体化搜索 & 导航 & 工具 -->
        <div class="header-right-group">
          <!-- 胶囊搜索系统 -->
          <div class="unified-search-pill">
            <div class="search-inner">
              <input 
                type="text" 
                v-model="searchKeyword" 
                placeholder="商品名"
                @keyup.enter="handleSearch"
              />
              <button class="search-btn" @click="handleSearch">
                <i class="el-icon-search"></i>
              </button>
            </div>
          </div>

          <!-- 核心导航 -->
          <nav class="action-nav">
            <ul class="nav-links">
              <li><router-link to="/" exact>首页</router-link></li>
              <li><router-link to="/brands">品牌库</router-link></li>
              <li><a href="#" @click.prevent="$refs.productFinder.openDialog()">商品代找</a></li>
              <!-- <li><router-link to="/partners">合作伙伴</router-link></li> -->
            </ul>
          </nav>

          <!-- 工具组 -->
          <div class="header-tools">
            <div class="tool-item message-pill" @click="goToMessage">
              <div class="icon-wrap">
                <i class="el-icon-bell"></i>
                <span class="count" v-if="unreadMessageCount > 0">{{ unreadMessageCount }}</span>
              </div>
              <span class="label">消息</span>
            </div>
            <div class="tool-item cart-pill" @click="goToCart">
              <div class="icon-wrap">
                <i class="el-icon-shopping-cart-2"></i>
                <span class="count" v-if="cartCount > 0">{{ cartCount }}</span>
              </div>
              <span class="label">购物车</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ProductFinder ref="productFinder" :hideBanner="true" />
  </div>
</template>

<script>
import { removeToken } from '@/utils/auth'
import { mapState, mapActions } from 'vuex'
import ProductFinder from '@/components/ProductFinder.vue'

export default {
  name: 'Header',
  components: {
    ProductFinder
  },
  data() {
    return {
      searchKeyword: '',
      isSticky: false,
      isSearchFocused: false,
      messageTimer: null
    }
  },
  computed: {
    ...mapState(['cartCount', 'unreadMessageCount', 'isLoggedIn', 'username', 'userInfo'])
  },
  watch: {
    isLoggedIn(newVal) {
      if (newVal) {
        this.startMessagePolling()
      } else {
        this.stopMessagePolling()
      }
    }
  },
  mounted() {
    this.fetchCartCount()
    this.fetchUnreadCount()
    this.fetchUserInfo()
    if (this.isLoggedIn) {
      this.startMessagePolling()
    }
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    this.stopMessagePolling()
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    ...mapActions(['fetchCartCount', 'fetchUnreadCount', 'fetchUserInfo']),
    startMessagePolling() {
      this.stopMessagePolling()
      // 每 30 秒轮询一次未读消息数
      this.messageTimer = setInterval(() => {
        if (this.isLoggedIn) {
          this.fetchUnreadCount()
        }
      }, 30000)
    },
    stopMessagePolling() {
      if (this.messageTimer) {
        clearInterval(this.messageTimer)
        this.messageTimer = null
      }
    },
    handleScroll() {
      this.isSticky = window.scrollY > 100
    },
    goToMessage() {
      this.$router.push('/message').catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err
      })
    },
    goToCart() {
      this.$router.push('/cart').catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err
      })
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeToken()
        this.$store.commit('LOGOUT')
        this.$message.success('已退出登录')
        this.$router.push('/login')
      }).catch(() => {})
    },
    handleSearch() {
      const keyword = this.searchKeyword.trim()
      const location = keyword 
        ? { path: '/list', query: { keyword: keyword } }
        : { path: '/list' }
        
      this.$router.push(location).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header-wrapper {
  width: 100%;
  background: #fff;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1000;
  position: relative;

  &.is-sticky {
    position: fixed;
    top: 0;
    left: 0;
    box-shadow: 0 4px 20px rgba(0,0,0,0.08);
    
    .top-utility {
      height: 0;
      overflow: hidden;
      opacity: 0;
    }
    
    .main-header-unified {
      height: 70px;
      background: rgba(255, 255, 255, 0.9);
      backdrop-filter: blur(20px);
    }
  }
}

.container {
  width: 1400px;
  max-width: 95%;
  margin: 0 auto;
}

/* 顶部工具栏 */
.top-utility {
  height: 36px;
  background: #1f2937;
  color: rgba(255,255,255,0.7);
  font-size: 12px;
  display: flex;
  align-items: center;
  transition: all 0.2s;

  .container {
    display: flex;
    justify-content: space-between;
  }

  a {
    color: rgba(255,255,255,0.7);
    margin-left: 18px;
    transition: color 0.2s;
    &:hover { color: #fff; }
  }

  .member-link {
    color: #fbbf24;
    font-weight: bold;
  }

  .member-review-tip {
    color: #fbbf24;
    margin-left: 18px;
    opacity: 0.8;
  }

  .sep {
    width: 1px;
    height: 10px;
    background: rgba(255,255,255,0.2);
    margin-left: 18px;
  }
}

/* 主航道 */
.main-header-unified {
  height: 90px;
  display: flex;
  align-items: center;
  transition: all 0.3s;

  .header-content {
    display: flex;
    align-items: center;
  }
}

/* Logo */
.logo-area {
  flex-shrink: 0;
  margin-right: 40px;
  
  .brand-text {
    font-size: 26px;
    font-weight: 900;
    color: #1a2a40;
    letter-spacing: -1px;
    margin: 0;
    
    span {
      color: #d97706;
      font-size: 32px;
    }
  }
}

/* 分类触发器 */
.category-trigger {
  margin-right: 30px;
  
  .trigger-btn {
    display: flex;
    align-items: center;
    background: #f3f4f6;
    padding: 10px 18px;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.2s;
    font-weight: bold;
    color: #374151;

    .menu-icon {
      width: 16px;
      height: 12px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-right: 10px;
      
      span {
        display: block;
        height: 2px;
        width: 100%;
        background: #374151;
        border-radius: 2px;
      }
    }

    &:hover {
      background: #e5e7eb;
      transform: translateY(-1px);
    }
  }
}

/* 布局组 */
.header-right-group {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 30px;
}

/* 胶囊搜索 */
.unified-search-pill {
  width: 320px;
  position: relative;

  .search-inner {
    display: flex;
    background: #f3f4f6;
    border: 1px solid transparent;
    border-radius: 50px;
    height: 38px;
    padding: 0 4px 0 16px;
    align-items: center;
    transition: all 0.3s;

    input {
      flex: 1;
      border: none;
      outline: none;
      font-size: 13px;
      background: transparent;
      color: #374151;
      &::placeholder { color: #9ca3af; }
    }

    .search-btn {
      width: 30px;
      height: 30px;
      background: #1a2a40;
      color: #fff;
      border-radius: 50%;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      transition: all 0.2s;
      
      &:hover {
        background: #d97706;
      }
    }

    &:focus-within {
      background: #fff;
      border-color: #d97706;
      box-shadow: 0 0 0 3px rgba(217, 119, 6, 0.1);
    }
  }
}

/* 导航 */
.action-nav {
  .nav-links {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      margin-left: 25px;
      
      a {
        font-size: 15px;
        color: #4b5563;
        font-weight: 500;
        text-decoration: none;
        transition: all 0.2s;
        
        &:hover, &.router-link-active {
          color: #d97706;
          font-weight: bold;
        }
      }
    }
  }
}

/* 工具组 */
.header-tools {
  display: flex;
  align-items: center;

  .tool-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    transition: all 0.2s;
    color: #374151;
    
    &:hover { color: #d97706; }
  }

  .message-pill, .cart-pill {
    padding: 0 15px;
    .icon-wrap {
      position: relative;
      font-size: 22px;
      
      .count {
        position: absolute;
        top: -4px;
        right: -6px;
        background: #d97706;
        color: #fff;
        font-size: 10px;
        min-width: 15px;
        height: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        border: 1px solid #fff;
      }
    }
    
    .label {
      font-size: 10px;
      margin-top: 1px;
      font-weight: bold;
    }
  }
}

@media (max-width: 1199px) {
  .action-nav { display: none; }
  .logo-area .brand-text { font-size: 20px; }
}
</style>
